module.exports = __webpack_public_path__ + "img/human-hair-wigs@2x.b3a23cae.jpg";